import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import css from 'cape-style'
import { StickyContainer, Sticky } from 'react-sticky'
import LinkEl from 'cape-mixer/lib/Link/Link'

import HomeWrapper from '../Home/HomeWrapper'
import Search from '../Search/Search'
import ShowItem from './ShowGroup'

import { Group, GroupBody, Blurb, Box, Wrapper, Top, Tag, SearchContainer } from './styles.css'

function ScheduleEl({ curatorialPracticeBlurb, showGroups }) {
  const { onCampusExhibition, singleDay, cityWide } = showGroups
  const collectionId = 'ShowGroup'
  return (
    <HomeWrapper>
      <StickyContainer>
        <article id="schedule">
          <Wrapper width="full" z={2}>
            <Box shadow align="flex-end">
              <Sticky>
                {({ style, isSticky }) => (
                  <div style={{ display: 'flex', justifyContent: 'flex-end', ...style }}>
                    <SearchContainer isSticky={isSticky}>
                      <Search
                        collectionId={collectionId}
                        style={css('flexAuto')}
                        isSticky={isSticky}
                      />
                    </SearchContainer>
                  </div>
                )}
              </Sticky>
            </Box>
          </Wrapper>

          <div style={{ minHeight: '2rem' }} />

          <Wrapper width="full">
            <Box shadow width="full">
              <Tag>
                Exhibition Schedule
                <LinkEl routeId="studentList">
                  <button>Student List</button>
                </LinkEl>
              </Tag>
              <StickyContainer>
                <Group>
                  <Sticky>
                    {({ style }) => (
                      <div style={style}>
                        <Top bt>Exhibitions</Top>
                      </div>
                    )}
                  </Sticky>
                  <GroupBody>
                    {onCampusExhibition &&
                      map(onCampusExhibition, item => <ShowItem key={item.id} {...item} />)}
                  </GroupBody>
                </Group>
              </StickyContainer>

              <StickyContainer>
                <Group>
                  <Sticky topOffset={1}>
                    {({ style }) => (
                      <div style={style}>
                        <Top bt>Events</Top>
                      </div>
                    )}
                  </Sticky>
                  <GroupBody>
                    {singleDay && map(singleDay, item => <ShowItem key={item.id} {...item} />)}
                  </GroupBody>
                </Group>
              </StickyContainer>

              <StickyContainer>
                <Group>
                  <Sticky topOffset={1}>
                    {({ style }) => (
                      <div style={style}>
                        <Top bt>Curatorial Practice</Top>
                      </div>
                    )}
                  </Sticky>
                  <GroupBody>
                    {cityWide && (
                      <Blurb dangerouslySetInnerHTML={{ __html: curatorialPracticeBlurb }} />
                    )}
                    {cityWide && map(cityWide, item => <ShowItem key={item.id} {...item} />)}
                  </GroupBody>
                </Group>
              </StickyContainer>
            </Box>
          </Wrapper>
        </article>{' '}
      </StickyContainer>
    </HomeWrapper>
  )
}
ScheduleEl.propTypes = {
  curatorialPracticeBlurb: PropTypes.string,
  showGroups: PropTypes.shape({
    onCampusExhibition: PropTypes.arrayOf(PropTypes.object),
    singleDay: PropTypes.arrayOf(PropTypes.object),
    cityWide: PropTypes.arrayOf(PropTypes.object),
  }),
}
ScheduleEl.defaultProps = {
  curatorialPracticeBlurb:
    'Students in MICA’s MFA in Curatorial Practice program complete curatorial projects and collaborate with artists, organizations, and venues. Each student works in a variety of contexts and formats while forging partnerships across audiences and communities. For additional information about participating artists, visitor hours, and public programs, visit each venue’s website or <a href="https://inside.mica.edu/curatorialpractice">inside.mica.edu/curatorialpractice</a>',
  showGroups: null,
}
export default ScheduleEl
